export default num => `https://picsum.photos/80/80?image=${num}`;



/** WEBPACK FOOTER **
 ** ./src/examples/faker-image.js
 **/